import { Metadata } from "@metaplex-foundation/mpl-token-metadata";
import { MintLayout, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { AccountMeta, PublicKey } from "@solana/web3.js";
import {
  ICollectionData,
  IDetailNftData,
  INftVoting,
} from "../../../common/interfaces/common.interface";
import {
  nftVoteRecordSeed,
  programFactory,
  RPC_CONNECTION,
} from "../utilities";

export const getNftTokenAccountsByOwner = async (wallet: PublicKey) => {
  const tokenAccounts = await RPC_CONNECTION.getParsedTokenAccountsByOwner(
    wallet,
    { programId: TOKEN_PROGRAM_ID }
  );

  return tokenAccounts.value.filter(
    (tokenAccount) =>
      tokenAccount.account.data.parsed.info.tokenAmount.decimals === 0 &&
      tokenAccount.account.data.parsed.info.tokenAmount.uiAmount >= 1
  );
};

// export const getNftFromCollection = async (
//   wallet: PublicKey,
//   collectionMint: PublicKey
// ): Promise<{
//   nftTokenAccount: PublicKey | undefined;
//   nftMetadata: PublicKey | undefined;
//   mint: PublicKey | undefined;
//   numberOfCreators: number;
// }> => {
//   try {
//     const nftTokenAccounts = await getNftTokenAccountsByOwner(wallet);
//     let nftTokenAccount: PublicKey | undefined;
//     let nftMetadata: PublicKey | undefined;
//     let nftMint: PublicKey | undefined;
//     let numberOfCreators: number = 0;
//     for (const nftTokenAcc of nftTokenAccounts) {
//       try {
//         const metadata = await Metadata.findByMint(
//           RPC_CONNECTION,
//           nftTokenAcc.account.data.parsed.info.mint
//         );

//         if (metadata.data.collection?.key === collectionMint.toString()) {
//           nftTokenAccount = nftTokenAcc.pubkey;
//           nftMetadata = await Metadata.getPDA(
//             nftTokenAcc.account.data.parsed.info.mint
//           );
//           nftMint = nftTokenAcc.account.data.parsed.info.mint;
//           numberOfCreators = metadata.data.data.creators?.length ?? 0;
//           break;
//         }
//       } catch (error) {
//         continue;
//       }
//     }
//     return {
//       nftTokenAccount: nftTokenAccount,
//       nftMetadata: nftMetadata,
//       mint: nftMint,
//       numberOfCreators,
//     };
//   } catch (error) {
//     console.log(error);
//     throw error;
//   }
// };

export const getRemainingAccountForMemberOfNFTClub = async (
  nftMetadata: PublicKey,
  nftTokenAccount: PublicKey
) => {
  const remainingAccounts: AccountMeta[] = [];

  if (nftMetadata && nftTokenAccount) {
    remainingAccounts.push(
      {
        pubkey: nftTokenAccount,
        isWritable: false,
        isSigner: false,
      },
      {
        pubkey: nftMetadata,
        isWritable: false,
        isSigner: false,
      }
    );
  }
  return remainingAccounts;
};

export const pareseNftDataToVotingData = async (
  nfts: IDetailNftData[],
  proposal: PublicKey
) => {
  const clubProgram = programFactory();
  const nftVotingData: INftVoting[] = [];
  for (const nft of nfts) {
    const [nftVoteRecordInfoAddress] = await PublicKey.findProgramAddress(
      [
        nftVoteRecordSeed,
        proposal.toBuffer(),
        new PublicKey(nft.mint).toBuffer(),
      ],
      clubProgram.programId
    );
    const nftVoteRecordTokenBallance = await RPC_CONNECTION.getBalance(
      nftVoteRecordInfoAddress
    );
    nftVotingData.push({
      ...nft,
      votedWithNft: nftVoteRecordTokenBallance > 0,
    });
  }
  return nftVotingData;
};

export async function getCollectionMintMetadata(
  collection: PublicKey
): Promise<ICollectionData | undefined> {
  try {
    const collectionMetadata = await Metadata.findByMint(
      RPC_CONNECTION,
      collection
    );
    if (!collectionMetadata.data.data.uri) {
      return {
        name: collectionMetadata.data.data.name,
        symbol: collectionMetadata.data.data.symbol,
        isVerified: collectionMetadata.data.collection?.verified,
      };
    }
    const responseData = await fetch(collectionMetadata.data.data.uri);
    const jsonData = await responseData.json();
    if (collectionMetadata.data.collection) {
      return {
        name: collectionMetadata.data.data.name,
        symbol: collectionMetadata.data.data.symbol,
        collectionAddress: collectionMetadata.data.collection.key,
        collectionImageUrl: jsonData.image.toString(),
        isVerified: collectionMetadata.data.collection?.verified ?? false,
      };
    }
    return {
      name: collectionMetadata.data.data.name,
      symbol: collectionMetadata.data.data.symbol,
      collectionImageUrl: jsonData.image.toString(),
      isVerified: false,
    };
  } catch (error) {
    console.log(error);
    return undefined;
  }
}

export async function checkIfCollectionIsInitialised(
  collectionAddress: string
) {
  try {
    const metadataAccount = await Metadata.findByMint(
      RPC_CONNECTION,
      new PublicKey(collectionAddress)
    );
    if (!metadataAccount.data.collection?.verified) {
      return false;
    }
    const accInfo = await RPC_CONNECTION.getAccountInfo(
      new PublicKey(collectionAddress)
    );
    if (accInfo) {
      return !!MintLayout.decode(accInfo.data);
    }
    return false;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
